import {observable, computed, extendObservable} from "mobx";
import {
    arrayToString, getByAtribute,
    stringToArray
} from "../../../utils/formatar";
import ETTService from "../../../services/ETTService";
import CompetenciaCargoService from "../../../services/CompetenciaCargoService";
import UsuarioService from "../../../services/UsuarioService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import EmpresaService from "../../../services/EmpresaService";
import OrdemCompraService from "../../../services/AcordoService";
import _ from "lodash"

export default class ETTStore {

    @observable ettList;
    @observable itemSelecionado;
    @observable usuarios;
    @observable competenciasCargo;
    @observable empresasGlobo;
    @observable cnpjInexistente;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.ettList = [];
        this.competenciasCargo = [];
        this.empresasGlobo = [];
        this.usuarios = [];
        this.usuariosFiltrados = [];
        this.resetItemSelecionado();
        this.ETTService = new ETTService();
        this.competenciaCargoService = new CompetenciaCargoService();
        this.usuarioService = new UsuarioService();
        this.empresaGloboService = new EmpresaGloboService();
        this.empresaService = new EmpresaService();
        this.ordemCompraService = new OrdemCompraService();

        this.cnpjInexistente = false;
        this.filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            nomeFantasia: "",
            razaoSocial: "",
            cnpj: "",
            contratosEttGlobo: [],
            competenciaCargoIds: "",
            competenciasCargo: [],
            usuarios: [],
            usuarioLogins: "",
            empresasGloboComContrato: "",
            ativo: true
        }
    }

    carregarLista() {
        this.loading = true;
        this.competenciasCargo = [];

        const loadingPromises = Promise.all([
            this.ETTService.list().then(response => {
                this.ettList = response.data;
            }).catch(error => {
                console.log(error);
            }),

            this.competenciaCargoService.list().then(response => {
                this.competenciasCargo = response.data;
            }).catch(error => {
                console.log(error);
            }),

            this.empresaGloboService.list().then(response => {
                this.empresasGlobo = response.data;
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data) {
                    this.usuariosFiltrados = response.data;
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: result,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: false
                });
                console.log(error);
            });
        } else {
            callback(null, {
                options: result,
                // CAREFUL! Only set this to true when there are no more options,
                // or more specific queries will not be sent to the server.
                complete: false
            });
        }
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    checkCNPJ() {
        this.modalStore.loading = true;
        if(this.itemSelecionado.cnpj) {
            this.empresaService.findById(this.itemSelecionado.cnpj).then(response => {
                this.modalStore.loading = false;
                this.itemSelecionado.nomeFantasia = response.data.nomeFantasia;
                this.itemSelecionado.razaoSocial = response.data.razaoSocial;
                this.cnpjInexistente = false;
            }).catch(error => {
                this.modalStore.loading = false;
                this.itemSelecionado.nomeFantasia = "";
                this.itemSelecionado.razaoSocial = "";
                this.cnpjInexistente = true;
                console.log(error);
            });
        } else {
            this.modalStore.loading = false;
            this.itemSelecionado.nomeFantasia = "";
            this.itemSelecionado.razaoSocial = "";
            this.cnpjInexistente = false;
        }

    }

    setTaxaAdministrativa(value, index) {
        this.itemSelecionado.contratosEttGlobo[index].taxaAdministracao = value;
    }

    setEmpresasGloboComContrato(value) {
        if(value) {
            const arrayValue = value.split(",");
            const novoValor = _.xor(this.itemSelecionado.contratosEttGlobo.map(c => "" + c.empresaGloboId), arrayValue);
            if(this.itemSelecionado.contratosEttGlobo.length < arrayValue.length && novoValor && novoValor.length === 1) {
                this.adicionarContrato(novoValor)
            } else if(novoValor && novoValor.length === 1){
                _.remove(this.itemSelecionado.contratosEttGlobo, {empresaGloboId: parseInt(novoValor[0])})
            }
            this.itemSelecionado.empresasGloboComContrato = value;
        } else {
            this.itemSelecionado.contratosEttGlobo = [];
            this.itemSelecionado.empresasGloboComContrato = value;
        }
    }

    setNumeroOrdemCompra(value, ordemCompra, index) {
        extendObservable(this.itemSelecionado.contratosEttGlobo[index], {
            ordemSelecionada: ordemCompra
        });
        this.itemSelecionado.contratosEttGlobo[index].numeroAcordo = value;
        this.itemSelecionado.contratosEttGlobo[index].orgIdOrdemCompra = ordemCompra ? ordemCompra.orgId : null;
    }

    adicionarContrato(empresaGloboId) {
        const empresaGlobo = getByAtribute(this.empresasGlobo, empresaGloboId, "id")
        const contrato = {
            id: 0,
            taxaAdministracao: 0,
            empresaGloboId: parseInt(empresaGloboId),
            empresaGlobo: empresaGlobo,
            ettId: 0,
            orgIdOrdemCompra: "",
            numeroOrdemCompra: null,
            numeroAcordo: null,
            ordemSelecionada: null,
            loadingOCs: false
        };
        this.modalStore.loading = true;
        this.itemSelecionado.contratosEttGlobo.push(contrato);
        this.ordemCompraService.listVigentesByContrato(empresaGlobo.codigoBu, this.itemSelecionado.cnpj).then(response => {
            if(response.data) {
                _.map(response.data, o => extendObservable(o, {labelValue: o.number}));
                contrato.ordensCompra = response.data;
            }
            this.modalStore.loading = false;
            this.itemSelecionado.contratosEttGlobo = this.itemSelecionado.contratosEttGlobo.map(c => {
                if(c.empresaGloboId === contrato.empresaGloboId){
                    return contrato;
                } else {
                    return c;
                }
            });
        }).catch(response => {
            this.modalStore.loading = false;
            contrato.numeroOrdemCompra = null;
            contrato.numeroAcordo = null;
            contrato.ordensCompra = [];
            return contrato;
        });
    }

    carregarOrdensCompraContratosIniciais() {
        if(this.itemSelecionado.contratosEttGlobo) {
            this.itemSelecionado.contratosEttGlobo.map((contrato, index) => {
                extendObservable(contrato, {loadingListaOcs: true});
                this.modalStore.loading = true;
                this.ordemCompraService.listVigentesByContrato(contrato.empresaGlobo.codigoBu, this.itemSelecionado.cnpj).then(response => {
                    if(response.data) {
                        _.map(response.data, o => extendObservable(o, {labelValue: o.number}));
                        contrato.ordensCompra = response.data;
                    }
                    contrato.loadingListaOcs = false;
                    this.modalStore.loading = false;
                    return contrato;
                }).catch(response => {
                    contrato.numeroOrdemCompra = null;
                    this.modalStore.loading = false;
                    contrato.ordensCompra = [];
                    contrato.loadingListaOcs = false;
                    return contrato;
                });

                extendObservable(contrato, {loadingOCSelecionada: true});
                this.ordemCompraService.obterPorNumeroAcordo(this.itemSelecionado.cnpj, contrato.numeroAcordo).then(response => {
                    if(response.data) {
                        response.data.labelValue = response.data.number;
                        this.setNumeroOrdemCompra(contrato.numeroAcordo, response.data, index);
                    }

                    contrato.loadingOCSelecionada = false;
                }).catch(response => {
                    contrato.numeroOrdemCompra = null;
                    contrato.ordensCompra = [];
                    contrato.loadingOCSelecionada = false;
                    return contrato;
                });
            });
        }
    }

    setCompetenciasCargoIds(value) {
        this.itemSelecionado.competenciaCargoIds = value;
    }

    setUsuarioLogin(value) {
        this.itemSelecionado.usuarioLogins = value;
        if(value) {
            const novosLogins = value.split(",");
            if(novosLogins.length > this.usuarios.length) {
                this.usuarios.push(getByAtribute(this.usuariosFiltrados, novosLogins.slice(-1).pop(), "login"));
            } else {
                this.removeUsuarioByLogins(novosLogins);
            }
        } else {
            this.usuarios = [];
        }
    }

    removeUsuarioByLogins(logins) {
        let indexToRemove = 0;
        for(let i=0;i < this.usuarios.length; i++) {
            if(this.usuarios[i].login !== logins[i]){
                indexToRemove = i;
                break;
            }
        }
        if(indexToRemove || indexToRemove === 0) {
            this.usuarios.splice(indexToRemove, 1);
        }
    }

    setNomeFantasia(value) {
        this.itemSelecionado.nomeFantasia = value;
    }

    setRazaoSocial(value) {
        this.itemSelecionado.razaoSocial = value;
    }

    setCNPJ(value, tipo) {
        this.itemSelecionado.cnpj = value;
        if(value.length === 14) {
            this.checkCNPJ(tipo);
        }
        this.itemSelecionado.contratosEttGlobo = [];
        this.itemSelecionado.empresasGloboComContrato = "";
    }

    setLista(value) {
        this.ettList = value;
    }

    @computed get empresasGloboOptions() {
        const result = this.empresasGlobo.slice();

        for(let i=0; i<this.itemSelecionado.contratosEttGlobo.length; i++) {
            for(let j=0; j<result.length;j++) {
                if(this.itemSelecionado.contratosEttGlobo[i].empresaGloboId === result[j].id) {
                    result.splice(j, 1);
                }
            }
        }
    }

    preencherModal(row){
        if(row) {
            this.resetItemSelecionado();
            this.ETTService.findById(row.id).then(response => {
                response.data.usuarioLogins = arrayToString(response.data.usuarios, "login", true);
                this.usuarios = response.data.usuarios.slice(0);
                response.data.competenciaCargoIds = arrayToString(response.data.competenciasCargo, "nome", true);
                response.data.empresasGloboComContrato = arrayToString(response.data.contratosEttGlobo,"empresaGloboId", true);
                this.itemSelecionado = response.data;
                this.carregarOrdensCompraContratosIniciais();
            }).catch(error => {
                console.log(error);
            });
        } else {
            this.usuarios = [];
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.ettList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        const form = Object.assign({}, this.itemSelecionado);

        form.usuarios = this.usuarios;
        form.competenciasCargo = stringToArray(this.competenciasCargo, form.competenciaCargoIds, "nome");

        return this.ETTService.edit(form.id, form).then(response => {
            this.ettList[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        const form = Object.assign({}, this.itemSelecionado);

        form.usuarios = this.usuarios;
        form.competenciasCargo = stringToArray(this.competenciasCargo, form.competenciaCargoIds, "nome");
        form.contratosEttGlobo.map((contrato) => {
            delete contrato.ordensCompra;
            return contrato
        });
        return this.ETTService.save(form).then(response => {
            this.ettList.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.ettList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.ETTService.delete(this.itemSelecionado.id).then(response => {
            this.ettList.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        });
    }


}